
<div style="display:flex; justify-content: space-between; column-gap: 80px;">
  <div>
    <h2 mat-dialog-title translate>NR.{{ incident.InquiryID }} {{ incident[localizedFields.get('Description')].toUpperCase() }}</h2>
  </div>

  <div>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
</div>
<mat-dialog-content>
  <mat-divider></mat-divider>
  <p class="improvement-data-title mt-2rem"><span translate>COMMONS.PRODUCT_REFERENCE</span>:</p>
  <p class="improvement-text"> {{ incident.ProductDescription }} {{incident.ReleaseNr}}</p>

  <mat-divider></mat-divider>

  <div class="mt-2rem">
    <ng-container *ngFor="let row of getOrderedInquiryRows(incident)" >
      <div *ngIf="getRowType(row)">
        <p class="improvement-data-title"><span translate>PRODUCTS.{{getRowType(row)}}</span> ({{ getDate(row.RecordingDate) }}) :</p>
        <p class="improvement-text">{{ row[localizedFields.get('Text')] }}</p>

        <button *ngIf="row.Attachments && row.DMSAttachmentID > 0" mat-button (click)="downloadArchiviedDocument(row.DMSAttachmentID, row.Attachments)" color="primary" style="margin-bottom: 1.6rem;">
            <mat-icon>download</mat-icon>
            {{ row.Attachments }}
        </button>

      </div>
    </ng-container>
  </div>

</mat-dialog-content>



